
import defineRoute, { ANNOTATION } from '../services/route';

export const NEW_ID = 'new';

export const SURVEY = defineRoute('/survey/:id', {
  params: [ANNOTATION.ID()]
});
